import Link from 'next/link';
import { rerawMarker } from 'utils/newsroom';
import styles from 'styles/modules/newsAlert/Newsroom.module.scss';

// Brands an alert as a Newspage Raw and links to the archive. A ReRawed alert
// says so, since its own date can be months old.
const RawBadge = ({ alert }) => {
    const reraw = rerawMarker(alert);

    return (
        <>
            <Link href="/raws">
                <a
                    className={styles.rawBadge}
                    title="Browse the Newspage Raws archive"
                >
                    <span>Newspage Raw</span>
                </a>
            </Link>
            {reraw && <span className={styles.rerawMarker}>{reraw}</span>}
        </>
    );
};

export default RawBadge;
